import instance from "../../api/Api";

/**
 *
 * @param {string} key key of pages which want to fetch navbar data
 * @returns page  config data
 */
export const page_config = (key) => {
  return instance.get(`/v1/common/page-config/${key}/`);
};

/**
 * Retrieves matched assets based on the provided parameters.
 *
 * @param {string} params - The parameters used to filter the assets.
 * @return {Promise<any>} A promise that resolves to the matched assets.
 */
export const matched_assets = (params) => {
  return instance.get(`v1/matched-assets/${params}`);
};

/**
 * Retrieves the matched assets for a given strategy based on the provided parameters.
 *
 * @param {string} params - The parameters used to filter the assets.
 * @return {Promise<any>} A promise that resolves to the matched assets.
 */
export const strategies_matched_assets = async (params) => {
  try {
    const response = await instance.get(
      `/v1/strategies/matches-assets/${params}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Sends a POST request to the server to mark a report as seen.
 *
 * @param {string} report_id - The ID of the report to be marked as seen.
 * @return {Promise} A promise that resolves to the response from the server.
 */
export const markReportSeen = (report_id) => {
  return instance.post(`/v1/report/${report_id}/add-user/`);
};
